
import './App.css';
import Encryption from './components/encrypt-words';

function App() {
  return (
    <div className="container">

      <Encryption />



    </div>
  );
}

export default App;
